
import {defineComponent} from "vue";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export default defineComponent({
  props: {
    dateTime: {type: String},
    empty: {type: String, default: "Nunca"},
  },
  methods: {
    dayjs(dateTime) {
      return dayjs.utc(dateTime)
    }
  }
});
